import { render, staticRenderFns } from "./OrticMysandozLogin.vue?vue&type=template&id=5041b19a&"
import script from "./OrticMysandozLogin.vue?vue&type=script&lang=js&"
export * from "./OrticMysandozLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports